<template>
    <academic>
        <div class="p-6 bg-white border-b border-gray-200 overflow-hidden shadow-sm sm:rounded-lg">
            <breeze-table :fields="fields" :items="courses" :action="{'text':'add course','url':route('academic.course.create')}" :searchlink="route('academic.course.search')" :canCreate="this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'Create Course')" :canView="this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'View Course')">
                <template #status="data">
                    {{data.item.status?'Active':'Inactive'}}
                </template>
                <template #type="data">
                    {{data.item.course_type.title}}
                </template>
                <template #action="data">
                    <button-link v-if="this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'Edit Course')" :href="route('academic.course.edit',data.item.id)" >Edit</button-link>
                </template>
            </breeze-table>
        </div>
    </academic>
</template>

<script>
    import Academic from '@/Pages/Academic/Academic'
    import BreezeTable from '@/Components/Table'
    import ButtonLink from '@/Components/ButtonLink'

    export default {
        components: {
            Academic,
            BreezeTable,
            ButtonLink
        },
        props:['courses'],
        data(){
            return{
                fields:[{'key':'code','label':'Code'},{'key':'title','label':'Title'},{'key':'duration','label':'Duration'},{'key':'eligibility','label':'Eligibility'},{'key':'type','label':'Type'},{'key':'status','label':'Status'},{'key':'action','label':'Action'}]
            }
        }
    }
</script>
